import { render, staticRenderFns } from "./userRequests.vue?vue&type=template&id=ed14b922&scoped=true&"
import script from "./userRequests.vue?vue&type=script&lang=js&"
export * from "./userRequests.vue?vue&type=script&lang=js&"
import style0 from "./userRequests.vue?vue&type=style&index=0&id=ed14b922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed14b922",
  null
  
)

export default component.exports